import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { useCallback } from "react";

type Props = {
  label: string;
  dataDe: Date | null;
  dataAte: Date | null;
  helperText?: string;
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: (dataDe: Date | null, dataAte: Date | null) => void;
};

export const DefaultDateRangePickerInput = ({
  label,
  dataDe,
  dataAte,
  helperText,
  required,
  readOnly,
  disabled,
  onChange,
}: Props) => {

  const handleOnChange = useCallback(
    (newValue: [Dayjs | null, Dayjs | null]) => {
      const [start, end] = newValue;

      let computedStart = null;
      let computedEnd = null;

      if (start && start.isValid()) {
        computedStart = start.toDate();
      }
      if (end && end.isValid()) {
        computedEnd = end.toDate();
      }
      onChange?.(computedStart, computedEnd);
    },
    [
      onChange,
    ]
  );

  return (
    <DateRangePicker
      value={[dataDe ? dayjs(dataDe) : null, dataAte ? dayjs(dataAte) : null]}
      onChange={handleOnChange}
      disabled={disabled}
      readOnly={readOnly}
      slotProps={{
        field: {
          clearable: true,
          onClear: () => onChange?.(null, null),
        },
        textField: {
          label: label,
          size: "small",
          fullWidth: true,
          required: required,
          error: !!helperText,
          helperText: helperText,
        },
      }}
    />
  );
};